var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.refresh)?_c('ejs-treeview',{ref:"moTreeCheck",attrs:{"id":"moTreeCheck","fields":_vm.checkTreeData,"showCheckBox":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }